const state = () => {
  return {
    parcels: [],
    parcel: {},
    parcel_set: {},
    parcel_filters: {},
    parcel_groups: [],
  }
}

export default state;
